import { render, staticRenderFns } from "./SFZ.vue?vue&type=template&id=0350b906&scoped=true&"
import script from "./SFZ.vue?vue&type=script&lang=js&"
export * from "./SFZ.vue?vue&type=script&lang=js&"
import style0 from "./SFZ.vue?vue&type=style&index=0&id=0350b906&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350b906",
  null
  
)

export default component.exports